import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-generic-error-customer',
  templateUrl: './generic-error-customer.component.html',
})
export class GenericErrorCustomerComponent {
  errorMessage: string;

  constructor(public modalService: ModalService) {
    this.errorMessage = this.modalService.currentDatas.errorMessage;
  }

  openLinkAndCloseModal(): void {
    window.open('https://www.castorama.fr/rangement-meuble-et-dressing/nos-collections-rangement-dressing/portes-placard-arius.cat', '_blank');
    this.modalService.close();
  }
}
